import { gettext } from '@eventbrite/i18n';
import { formatMajorMoney } from '@eventbrite/intl';
import { TicketCost } from './types';

export const formatPrice = (value: number, currency: string) =>
    formatMajorMoney(value, currency, '¤#,##0.00');

export const renderFeeText = (fee: TicketCost) => {
    const displayFee = formatPrice(fee.value, fee.currency);
    return gettext('+%(displayFee)s Fee', { displayFee });
};

export const renderTaxText = (tax: TicketCost) => {
    const displayTax = formatPrice(tax.value, tax.currency);
    return gettext('+%(displayTax)s Tax', { displayTax });
};
